export const SET_DEALER_LOCATOR_SEARCHED_PLACE = 'SET_DEALER_LOCATOR_SEARCHED_PLACE';
